/**
 * Builds two or three initials from a display name.
 */
export function initials(name: string): string {
  const allInitials = name
    .trim()
    .split(/[\s-]+/)
    .filter((word) => word.length > 0)
    .map((word) => word.charAt(0).toUpperCase());

  if (allInitials.length > 2) {
    return allInitials[0] + allInitials[allInitials.length - 2] + allInitials[allInitials.length - 1];
  }

  return allInitials.join('');
}
